export const TREE_METRIC_EVENT = {
    rebirth: 'rebirth',
    resetCount: 'Reset Count'
}